export default {
    props: {
        animationCollapseDuration: {
            type: Number,
            kComposite: 'animation.collapse.duration'
        }, 
        animationCollapseEffects: {
            type: String,
            kComposite: 'animation.collapse.effects'
        }, 
        animationExpandDuration: {
            type: Number,
            kComposite: 'animation.expand.duration'
        }, 
        animationExpandEffects: {
            type: String,
            kComposite: 'animation.expand.effects'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoPanelBar/Animation.js